import GenericPopup from "@/shared-components/popups/components/GenericPopup";

import "./styles/MarinaTipPopup.css";

const MarinaTipPopup = ({ open, onClose, videoUrl }) => {
  const hasVideo = Boolean(videoUrl);

  return (
    <GenericPopup open={open} onCloseAction={onClose} closeButtonText="Close" className="marina-tip__container" opacity>
      <div className="marina-tip__content">
        <h3 className="marina-tip__title">Marina’s tip</h3>
        {hasVideo ? (
          <video className="marina-tip__video" controls playsInline>
            <source src={videoUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <p className="marina-tip__fallback">
            We will share Marina’s tip for this artwork very soon.
          </p>
        )}
      </div>
    </GenericPopup>
  );
};

export default MarinaTipPopup;
